import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '../../../../../Apollo/Mutation';
import SetInitialPasswordMutation from './AuthSetInitialPasswordMutation';

class SetInitialPasswordConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    createSetPassword = mutate => async request => {
        const variables = request;

        const response = await mutate({
            variables,
        });

        return response;
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={SetInitialPasswordMutation}>
                {mutate =>
                    children({
                        setPassword: this.createSetPassword(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default SetInitialPasswordConnectorApollo;
